<template>
	<div>
		<!-- Start Page Title -->
		<div class="page-title-area">
			<div class="d-table">
				<div class="d-table-cell">
					<div class="container">
						<h2>Administration Système Windows Server (2008, 2012, 2016)</h2>
					</div>
				</div>
			</div>

			<div class="shape1"><img src="../../../../assets/img/shape1.png" alt="IT+ formation cours informatique djibouti"></div>
			<div class="shape2 rotateme"><img src="../../../../assets/img/shape2.svg" alt="IT+ formation cours informatique djibouti"></div>
			<div class="shape3"><img src="../../../../assets/img/shape3.svg" alt="IT+ formation cours informatique djibouti"></div>
			<div class="shape4"><img src="../../../../assets/img/shape4.svg" alt="IT+ formation cours informatique djibouti"></div>
			<div class="shape5"><img src="../../../../assets/img/shape5.png" alt="IT+ formation cours informatique djibouti"></div>
			<div class="shape6 rotateme"><img src="../../../../assets/img/shape4.svg" alt="IT+ formation cours informatique djibouti"></div>
			<div class="shape7"><img src="../../../../assets/img/shape4.svg" alt="IT+ formation cours informatique djibouti"></div>
			<div class="shape8 rotateme"><img src="../../../../assets/img/shape2.svg" alt="IT+ formation cours informatique djibouti"></div>
		</div>
		<!-- End Page Title -->

		<!-- Start Services Details Area -->
		<section class="services-details-area ptb-80">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-lg-6 services-details">
						<div class="services-details-desc">
							<h3>Prenez le controle des serveurs windows</h3>
							<p>Windows Serveur est un système d’exploitation très déployé dans les infrastructures
								professionnelles. Cette formation Installation et configuration de Windows Server vous
								permettra
								d’être très opérationnel sous Windows Serveur tels que les versions 2008, 2012 ou 2016.
							</p>
							<p>
								Pendant cette formation Windows Server, vous allez tout d’accord voir comment installer
								et
								configurer un serveur Windows de base avant de commencer à implémenter les différents
								services :
								services de domaines Active Directory, serveur DHCP, serveur DNS, serveur de fichiers et
								d’impression. Aussi durant cette formation Windows Server, vous allez comprendre et
								implémenter
								l’adressage IPv4 et IPv6 sous Windows, et aussi apprendre comment automatiser des tâches
								avec
								PowerShell.</p>


						</div>
					</div>

					<div class="col-lg-6 services-details-image">
						<img src="../../../../assets/img/courses/winserver.jpeg" class="wow fadeInUp" alt="IT+ Code Lab">
					</div>
				</div>

				<div class="separate"></div>

				<div class="row align-items-center">
					<div class="col-lg-6 services-details-image">
						<img src="../../../../assets/img/courses/win server.jpeg" class="wow fadeInUp" alt="IT+ Code Lab">
					</div>

					<div class="col-lg-6 services-details">
						<div class="services-details-desc">
							<p>À la fin de ce cours, vous serez capable de :</p>
							<ul>
								<li>Installer et configurer Microsoft Windows Server (2008, 2012 ou 2016)
									;</li>
								<li>
									Comprendre et gérer les services de domaines Active Directory ;</li>
								<li>
									Gérer comptes utilisateurs et ordinateurs sous Active Directory ;</li>
								<li>
									Déléguer l’administration des services de domaine Active Directory
									;</li>
								<li>
									Automatiser des tâches Active Directory en ligne de commande et avec des scripts
									PowerShell;</li>
								<li>Comprendre et mettre en place IP v4 et IPv6 sous Windows serveur;</li>
								<li>Installer et gérer le serveur DHCP sous Windows serveur ;</li>
								<li>Comprendre et administrer le service DNS sous Windows serveur ;</li>
								<li>Gérer le stockage local, les services de fichiers et imprimantes sous Windows
									serveur ;</li>
							</ul>

							<!--
							<div class="services-details-accordion">
								<VueFaqAccordion :items="myItems" />
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- End Services Details Area -->

		<!-- <div class="container">

			<div class="row  justify-content-center ">


				<div class="col-lg-4 col-md-6 col-sm-6">
					<div class="pricing-table active-plan">
						<div class="pricing-header">
							<h3>Angular</h3>
						</div>

						<div class="price">
							<span><sup>Fdj</sup>15000 <span>/Mois</span></span>
						</div>

						<div class="pricing-features">
							<ul>
								<li class="active">Durée de la formation : 3 mois</li>
								<li class="active">Matériels requis: Laptop core i5, 8GB RAM, 1TB Hard Disk</li>

							</ul>

						</div>
						<h6>Prérequis: </h6>
						<div class="pricing-features">

							<ul>
								<li class="active">Avoir une bonne expérience du système d’exploitation
									Microsoft Windows et des principes fondamentaux des réseaux, Connaitre
									les clients Windows 7, Windows 8 ou Windows 10 serait un atout.</li>

							</ul>
						</div>


					</div>
				</div>

			</div>
		</div> -->
	</div>
</template>

<script setup>
useHead({
  title: "Administration Windows Server - IT+ CODE LAB",
  meta: [
    { name: "description", content: "Maîtrisez l'administration des serveurs Windows et optimisez la gestion des infrastructures IT. | Code Lab | Cours et Formations en informatique à Djibouti" },
    { name: "keywords", content: "formation,windows,serveur,administration,cours,Djibouti" }
  ],
});</script>
